import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "acProject" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_lottie_preloader = _resolveComponent("ac-lottie-preloader")!
  const _component_mobile_subscription = _resolveComponent("mobile-subscription")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_push_prompt = _resolveComponent("push-prompt")!
  const _component_toast_container = _resolveComponent("toast-container")!
  const _component_MobAppQRModal = _resolveComponent("MobAppQRModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ac_lottie_preloader)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.isMobileSubscription)
            ? (_openBlock(), _createBlock(_component_mobile_subscription, { key: 0 }))
            : (_openBlock(), _createBlock(_component_router_view, { key: 1 })),
          _createVNode(_component_push_prompt)
        ], 64)),
    _cache[0] || (_cache[0] = _createElementVNode("div", { id: "modals" }, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { id: "popups" }, null, -1)),
    _createVNode(_component_toast_container),
    (_ctx.mobileAppDesktopQrModalVisible)
      ? (_openBlock(), _createBlock(_component_MobAppQRModal, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}